import get from 'lodash/get';

export const bodyCategories = (results, categories) => {
  const autoBodyObj = {};
  let bodyBuf = {};
  for (let a = 0, b = results.length; a < b; a += 1) {
    const autoBody = get(results[a], 'modification.series.title', false);
    if (autoBody) {
      if (!autoBodyObj[autoBody]) {
        autoBodyObj[autoBody] = 1;
      } else if (autoBodyObj[autoBody]) {
        autoBodyObj[autoBody] += 1;
      }
    }
  }
  Object.keys(autoBodyObj).map(a => {
    if (!bodyBuf.count || bodyBuf.count < autoBodyObj[a]) {
      bodyBuf = {
        count: autoBodyObj[a],
        title: a,
      };
    }
    return '';
  });
  for (let a = 0, b = categories.length; a < b; a += 1) {
    if (
      typeof categories[a].title === 'string' &&
      typeof bodyBuf.title === 'string' &&
      new RegExp(categories[a].title, 'i').test(bodyBuf.title)
    ) {
      return categories[a].slug;
    }
  }

  return '';
};



// WEBPACK FOOTER //
// ./src/shared/routes/search/categoriesSearch.js